import { superFetch } from 'commons'

export const fetchProviders = () => {
  return superFetch({ url: 'fournisseur' })
}
